<template>
  <div class="Product">
    <!---NAVIGATOR-->
    <Header />
    <div class="modal-container" :class="{ nonemodal: carrito2.mdc !== 'map' }">
      <modalAddPro @close="mdadd = false" :class="{ transitionL: carrito2.mdc == 'map' }" />
    </div>

    <div class="modal-container" :class="{ nonemodal: carrito2.mdc !== 'mdc' }">
      <ModalCar @close="mdcar = false" :class="{ transitionL: carrito2.mdc == 'mdc' }" />
    </div>

    <div class="pro-b">
      <div class="pro-pd">

        <div class="s1">
          <div class="gal mo">
            <div style="position: relative;" v-if="data.imagenes?.length == 1">
              <img :src="srcImg(data.image)" alt="img-sel" class="img-sel" />
              <img src="../assets/sold.png" alt="Sold Out" class="sold-out" v-if="data.stock == 0">
            </div>
            <carousel :perPage="1" :navigationEnabled="false" :paginationEnabled="false"
              v-if="data.imagenes?.length > 1">
              <slide v-for="(gi, i) in data.imagenes" :key="i"><img :src="srcImg(gi.image)" alt="img-sel"
                  class="img-sel" /></slide>
            </carousel>
            <div class="col"></div>
          </div>
          <div class="gal pc">
            <img :src="srcImg(imgsel !== '' ? imgsel : data.image)" alt="img-sel" class="img-sel" v-if="data.image" />
            <div v-if="data.image">
              <div class="scrollgal"> <!-- @touchmove="onMouseMove" @drag="onMouseMove"--->
                <section :style="{ bottom: (galpos * galnu) + 'vw' }">
                  <img :src="srcImg(data.image)" alt="" @click="imgsel = data.image"
                    :class="{ 'pev': galdrag == true }" />
                  <img v-for="(gi, i) in data.imagenes" :key="i" :src="srcImg(gi.image)" alt=""
                    @click="imgsel = gi.image" :class="{ 'pev': galdrag == true }" />
                </section>
              </div>
              <div class="arrows" v-if="data.imagenes.length > 1">
                <p class="up" @click="galnu = galnu - 1" :class="{ 'pev': galnu == 1 }">
                  < </p>
                    <p class="down" @click="galnu = galnu + 1" :class="{ 'pev': galnu == (data.imagenes.length - 1) }">>
                    </p>
              </div>
            </div>
          </div>
          <!--Información-->
          <div class="info-c">
            <div class="i-pd">
              <!--Título-->
              <div class="tl">
                <section>
                  <p class="producto__nombre">{{ data.name }}</p>
                  <img src="../assets/sout.svg" alt="" class="s-out pc"
                    v-if="(data.stock == 0) || (data.stock == 'Sin stock')" />
                </section>
                <p class="num" v-if="data.code?.toString().length > 3">{{ data.code }}</p>
                <p class="num" v-else-if="data.code == undefined || data.code == null || data.code == ''"></p>
                <p class="num" v-else>{{ '0'.repeat(3 - data.code?.toString().length) + data.code?.toString() }}</p>
              </div>
              <!--Descripción -->
              <p class="desc">{{ data.descr }}</p>
              <div class="mosaicpc">
                <!-- De aquí -->
                <div class="col" v-if="data.atributosFilt.length > 0">

                  <div class="only-mov mov__wrapper" v-if="data.atributosFilt[0].atributo == 'SABOR'">
                    <section>
                      <div class="sz-c-tl dflx" :class="{ cienpor: data.more_pro == 'SI' }">
                        <p v-if="data.more_pro !== 'NO' && data.atributosFilt[0]?.atributo == 'SABOR'">
                          <span>*</span>
                          SABOR
                        </p>
                      </div>
                      <div class="sz-c-cont sabor__mov" :class="{ cienpor: data.more_pro == 'SI' }">
                        <div class="flavor" v-for="(item, key) in data.atributosFilt" :key="key"
                          v-if="item.tipo == 'multiple' && item.atributo == 'SABOR'">
                          <div tabindex="0" class="s-num"
                            @click="select2 == true ? (select2 = false) : (select2 = true)"
                            @keyup.enter="select2 == true ? (select2 = false) : (select2 = true)">
                            <b>{{ item.sel }}</b><img src="../assets/flechared.svg" alt="img" />
                          </div>
                          <div class="s-num-sel" v-if="select2 == true">
                            <p tabindex="0" v-for="(valor, key2) in item.values" :key="key2"
                              @click="
                                (select2 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)"
                              @keyup.enter=" (select2 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)">
                              {{ valor }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>

                  <section>
                    <div class="sz-c-tl dflx" :class="{ cienpor: data.more_pro == 'SI' }">
                      <p
                        v-if="data.more_pro !== 'NO' && (data.atributosFilt[0]?.atributo == 'PESO' || data.atributosFilt[1]?.atributo == 'PESO')">
                        <span>*</span>
                        TAMAÑO
                      </p>
                      <p class="only-pc" v-if="data.more_pro !== 'NO' && data.atributosFilt[0]?.atributo == 'SABOR'">
                        <span>*</span>
                        SABOR
                      </p>
                      <p :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock') }">
                        <span>*</span>
                        CANTIDAD
                      </p>
                    </div>
                    <div class="sz-c-cont" :class="{ cienpor: data.more_pro == 'SI' }">
                      <div class="size" v-for="(item, key) in data.atributosFilt" :key="key"
                        v-if="item.tipo == 'unico' && item.atributo == 'PESO'">
                        <div tabindex="0" class="s-num" @click="select1 == true ? (select1 = false) : (select1 = true)"
                          @keyup.enter="select1 == true ? (select1 = false) : (select1 = true)">
                          <b>{{ item.sel }}</b><img src="../assets/flechared.svg" alt="img" />
                        </div>
                        <div class="s-num-sel" v-if="select1 == true">
                          <p tabindex="0" v-for="(valor, key2) in ordenar(item.values, item.atributo)" :key="key2"
                            @click="
                              (select1 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)"
                            @keyup.enter=" (select1 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)">
                            {{ valor }}
                          </p>
                        </div>
                      </div>
                      <div class="flavor only-pc" v-for="(item, key) in data.atributosFilt" :key="key"
                        v-if="item.tipo == 'multiple' && item.atributo == 'SABOR'">
                        <div tabindex="0" class="s-num" @click="select2 == true ? (select2 = false) : (select2 = true)"
                          @keyup.enter="select2 == true ? (select2 = false) : (select2 = true)">
                          <b>{{ item.sel }}</b><img src="../assets/flechared.svg" alt="img" />
                        </div>
                        <div class="s-num-sel" v-if="select2 == true">
                          <p tabindex="0" v-for="(valor, key2) in item.values" :key="key2"
                            @click="
                              (select2 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)"
                            @keyup.enter=" (select2 = false), (item.sel = valor), (Categorias[key].sel = valor), findProd(item.atributo, valor, data)">
                            {{ valor }}
                          </p>
                        </div>
                      </div>
                      <div class="cant"
                        :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock'), 'solo': data.atributosFilt.length < 2 && data.atributosFilt[0].atributo == 'SABOR' }">
                        <p tabindex="0" @click=" selectNumb > 1 ? (selectNumb = selectNumb - 1) : selectNumb"
                          @keyup.enter=" selectNumb > 1 ? (selectNumb = selectNumb - 1) : selectNumb">
                          -
                        </p>
                        <p class="num">{{ selectNumb }}</p>
                        <p tabindex="0" @click="selectNumb = selectNumb + 1" @keyup.enter="selectNumb = selectNumb + 1"
                          :class="{ 'block': (selectNumb == data.stock) }">+</p>
                      </div>
                    </div>
                    <div v-if="selectNumb == data.stock">
                      <p class="limite"> <span>¡¡¡</span> Haz llegado a nuestro límite en almacén <span>!!!</span></p>
                    </div>
                  </section>

                  <div class="atr">
                    <section class="dflx" v-for="(item, key) in data.product_atributo_valores" :key="key">
                      <div class="dflx" v-if="item.atributo == 'CARACTERISTICA'">
                        <img src="../assets/sfree.svg" alt="sugarfree" v-if="item.valor == 'SUGAR FREE'" />
                        <img src="../assets/vegano.svg" alt="vegano" v-if="item.valor == 'VEGANO'" />
                        <img src="../assets/keto.svg" alt="keto" v-if="item.valor == 'KETO'" />
                      </div>
                    </section>
                  </div>
                </div>
                <div v-else class="col">
                  <section>
                    <div class="sz-c-tl grid" :class="{ cienpor: data.more_pro == 'SI' }">
                      <p :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock') }">
                        <span>*</span>
                        CANTIDAD
                      </p>
                      <div class="sz-c-cont" :class="{ cienpor: data.more_pro == 'SI' }">
                        <div class="cant" :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock') }">
                          <p tabindex="0" @click=" selectNumb > 1 ? (selectNumb = selectNumb - 1) : selectNumb"
                            @keyup.enter=" selectNumb > 1 ? (selectNumb = selectNumb - 1) : selectNumb">
                            -
                          </p>
                          <p class="num">{{ selectNumb }}</p>
                          <p tabindex="0" @click="selectNumb = selectNumb + 1"
                            @keyup.enter="selectNumb = selectNumb + 1" :class="{ 'block': (selectNumb == data.stock) }">
                            +</p>
                        </div>
                      </div>
                      <div v-if="selectNumb == data.stock">
                        <p class="limite"> <span>¡¡¡</span> Haz llegado a nuestro límite en almacén <span>!!!</span></p>
                      </div>
                    </div>

                  </section>
                </div>
                <!-- A acá -->
                <div class="linea" v-if="data.atributosFilt?.length < 2">
                </div>
                <div class="col">
                  <!--Precio-->
                  <p class="price" v-if="parseFloat(data.price).toFixed(2) != 'NaN'">${{
                    parseFloat(data.price).toFixed(2)
                  }}</p>
                  <p class="price" v-else></p>
                  <!--Añadir al carrito-->
                  <div class="btn mo" @click="agregarACesta(selectNumb, data, 'mo')"
                    :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock') }">
                    AÑADIR A CARRITO
                  </div>
                  <div tabindex="0" class="btn pc" @click="agregarACesta(selectNumb, data, 'pc')"
                    @keyup.enter="agregarACesta(selectNumb, data, 'pc')"
                    :class="{ 'block': (data.stock == 0) || (data.stock == 'Sin stock') }">
                    AÑADIR A CARRITO
                  </div>
                </div>
                <div v-if="status != ''" class="status_messages">
                  <div v-if="status == 'success'" class="msg msg_success">
                    <p>{{ message }}</p>
                  </div>
                  <div v-if="status == 'error'" class="msg msg_error">
                    <p>{{ message }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Acaba la info -->
          <!-- {{dataExtras}} -->
          <div class="atributos-ex" v-for="(item, key) in data.atributosFilt" :key="key"
            v-if="item.tipo == 'multiple' && item.atributo == 'SABOR'">
            <p tabindex="0" v-for="(v, j) in item.values" :key="j" :class="{ sel: item.sel == v }">
              {{ v }}
            </p>
          </div>
        </div>
        <!-- <ProRelacionados /> -->
      </div>
    </div>
    <!---FOOTER-->
    <Footer ref="hijo" />
  </div>
</template>
<script>
let { url } = require("../global/index");
import { mapActions } from "vuex";
import { Carousel, Slide } from "vue-carousel";
import Header from "../components/fixed/Header.vue";
import Footer from "../components/Footer.vue";
//import ProRelacionados from "../components/pag-producto/ProRelacionados.vue";
import modalAddPro from "./carrito/modalAddPro.vue";
import ModalCar from "./carrito/modalCar.vue";

export default {
  name: "Producto",
  data() {
    return {
      select1: false,
      select2: false,

      sliderCounter: 1,

      drag: false,
      dragX: 0,
      dragY: 0,
      dragXt: 0,
      dragYt: 0,

      imgsel: "",//this.data.imagenes[0].image,
      galpos: 13.698,
      galnu: 1,
      galdrag: false,

      url: url,
      selectM: "",
      cantidad: 1,
      selectWeek: "1 semana",
      weeks: ["4 semanas", "1 semana", "2 semanas", "3 semanas"],
      openWeeks: false,
      Gramos: "",
      Molido: "",
      Categorias: [],

      hover1: false,
      editco: 0,
      selectNumb: 1,
      status: "",
      message: "",
      status2: "",
      message2: "",
      name:
        localStorage.getItem("sdel") === null
          ? ""
          : localStorage.getItem("sdel"),
      email:
        localStorage.getItem("sdel") === null
          ? ""
          : localStorage.getItem("sdel"),
      comment: "",
      valuation: 0,
      hoverval: 0,
      tosave: false,
      closeU:
        localStorage.getItem("sdne") === null &&
          localStorage.getItem("sdel") === null
          ? false
          : true,
      messageError: "",
      titlego: "",
      imagesel: "",
      pageNum: 1,
      pageSize: 3,
      arraylength: 0,
      logisav: localStorage.getItem("tkn") === null ? false : true,
      mdcar: false,
      mdadd: false,
    };
  },
  components: {
    Header,
    Footer,
    Carousel,
    Slide,
    modalAddPro,
    ModalCar,
  },
  metaInfo() {
    return {
      title: this.data.name,
      titleTemplate: "%s | Huupa",
      htmlAttrs: {
        lang: "es",
      },
      meta: [
        { charset: "utf-8" },
        {
          name: "description",
          content: this.data.descrp,
        },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
      ],
    };
  },

  async created() {
    await this.getIdentity();


    //localStorage.getItem("mdc");
    //localStorage.setItem("mdc", "false");
    this.mdcar = localStorage.getItem('mdc');

    if (this.$route.name == "Producto") {
      localStorage.setItem("pdt", this.$route.params.url);
    }

    let url2 =
      this.$route.name !== "Producto"
        ? localStorage.getItem("pdt")
        : this.$route.params.url;

    await this.findByUrlPrd({
      option: "product/url",
      url: url2,
    });

    let ruta
    if (this.data.status === 'INACTIVO') {
      ruta = this.data.product_variantes.find(producto => producto.producto.status === 'ACTIVO').producto.url
    }

    if (ruta) {
      window.location.href = `/producto/${ruta}`;
    }


  },
  computed: {
    identity() {
      return this.$store.getters["admin/getIdentity"];
    },
    carrito2() {
      return this.$store.getters["carrito/getAdded2"];
    },

    datacat() {
      let arr = this.$store.getters["category/data"];
      let narr = [];

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].parent_name == "MENU") {
          narr.push(arr[i])
        }
      }
      return narr
    },

    data() {
      let data = this.$store.getters["product/data"];
      this.Categorias = [];
      this.titlego = data.name;

      if (data.atributosFilt && this.Categorias.length == 0) {
        for (let item of data.product_atributo_valores) {

          let obj = {
            cat: item.atributo,
            sel: item.valor,
          };
          this.Categorias.push(obj);
        }
      }

  
      return data;
    },



    atrFilt() {
      let data = this.data.atributosFilt;
      let arr = [];

      let sorter = (a, b) => {
        if (a["tipo"] == "unico" && b["tipo"] == "unico") {
          return -1;
        }
      };
      arr.sort(sorter);
      for (let i = 0; i < data.length; i++) {
        if (data[i].tipo == "unico") {
          arr.push();
        }
      }
      return data;
    },
    addedCo() {
      let array = this.$store.getters["product_val/getAdded"];
      this.arraylength = array.length;
      if (array == "error") {
        return "error";
      } else {
        let arr = array.slice(
          (this.pageNum - 1) * this.pageSize,
          this.pageNum * this.pageSize
        );
        return arr;
      }
    },
    proId2() {
      let arr = this.$store.getters["product_val/data"];
      if (this.editco == 0) {
        return "error";
      } else {
        let added = [];
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == this.editco) {
            added.push(arr[i]);
          }
        }
        return added;
      }
    },
    totalPages() {
      let total = Math.ceil(this.arraylength / this.pageSize);
      if (total < this.pageNum) {
        this.pageNum = 1;
      }
      return total;
    },
    gp() {
      let arr = this.$store.getters["global_params/data"];
      let filter = [];
      if (!Array.isArray(arr)) {
        return [];
      } else {
        filter = arr;
      }

      return filter;
    },
  },
  methods: {
    ...mapActions("product", ["findByUrlPrd"]),
    ...mapActions("product", ["getInfoByIdPrd"]),
    ...mapActions("product_val", ["setAddedPrdVal"]),
    ...mapActions("product_val", ["getInfoByIdPrdVal"]),
    ...mapActions("product_val", ["getAllInfoPrdVal"]),
    ...mapActions("category", ["getAllInfoCtg"]),
    ...mapActions("global_params", ["getAllInfoGlp"]),
    ...mapActions("carrito", ["getCart"]),
    ...mapActions("carrito", ["getCartCopy"]),
    ...mapActions("carrito", ["setAddedCrt"]),
    ...mapActions("carrito", ["setAddedCrt2"]),
    ...mapActions("catstore", ["setAddedCts"]),




    slider(lado) {
      const slider = document.querySelector('.menu__home');

      if (lado == "derecha") {
        slider.scrollLeft += slider.offsetWidth;
      } else {
        slider.scrollLeft -= slider.offsetWidth;
      }
    },


    ordenar(values, atr) {
      let arr = [];
      if (atr !== 'TAMAÑO') {
        for (let index = 0; index < values.length; index++) {
          arr.push(values[index])
        }

        for (let index = 0; index < arr.length; index++) {
          if (arr[index].includes("kg")) {
            arr[index] = arr[index].replace("kg", "000")
          }
          if (arr[index].includes("grs")) {
            arr[index] = arr[index].replace("grs", "")
          }
        }

        arr.sort((a, b) => a - b)
        for (let index = 0; index < arr.length; index++) {
          if (arr[index] > 999) {
            arr[index] = arr[index] / 1000
          }
        }

        arr = arr.map((numero) => numero.toString())
        for (let index = 0; index < arr.length; index++) {
          if (arr[index].length == 1) {
            arr[index] = arr[index] + "kg"
          } else {
            arr[index] = arr[index] + "grs"
          }
        }
        return arr
      }
    },

    onMouseMove: function (event) {
      //this.galdrag = true;
      this.galpos = event.offsetY;
    },

    orderCat: function (atributos_C) {
      /*let catsN=[], cats=[];
 
            catsN.push(atributos_C[0].atributo)
 
            for(let item of atributos_C){
                
                if(!catsN.includes(item.atributo)){
                    catsN.push(item.atributo)
                }
            }
 
            for(let item of catsN){
 
                let obj={
                    atributo:item,
                    valores:[]
                }
                cats.push(obj)
 
                for(let item2 of atributos_C){
                    
                }
 
            }
          
 
            return cats;*/
    },

    getIdentity: async function () {
      let response = await this.$store.dispatch("admin/getData");
      return response;
    },


    async obtenerCarritos() {
      await this.getCart();
      await this.getCartCopy();
    },

    agregarACesta: async function (cantidad, arrsele, device) {

      let _ctk = localStorage.getItem("_ctk")
      if(!_ctk || _ctk === undefined || _ctk === null || _ctk === ''){
        await this.$store.dispatch("carrito/setCart", {
          option: "set_cart",
          item: { id_cliente: null },
        });
        _ctk = localStorage.getItem("_ctk")
      }

      let payload = {
        item: arrsele,
        _ctk ,
        cantidad,
      };

      let result = await this.$store.dispatch("carrito/editItemCrt", {
        option: "add_item",
        item: payload,
      });



      if (result.status == "error") {
        this.status = "error";



        if (result.message == 'Ha superado el stock disponible para este producto.') {
          this.message = result.message
        } else {
          this.message =
            "Ha ocurrido un error al intentar actualizar el carrito.";
        }
        this.delStatus();
      } else {
        // success
        await this.obtenerCarritos();

        if (device == "pc") {
          let payload = {
            ...arrsele,
            cantidad: cantidad,
          };
          await this.setAddedCrt(payload);
          //this.mdadd = true;
          let payload3 = {
            mdc: 'map',
          }
          await this.setAddedCrt2(payload3)
          //this.$router.push("/addtocar").catch((err) => {});
        }
        if (device == "mo") {
          this.mdcar = true;
          let payload3 = {
            mdc: 'mdc',
          }
          await this.setAddedCrt2(payload3)
          //this.$router.push("/cesta").catch((err) => {});
        }
      }
    },

    delStatus: function () {
      setTimeout(() => this.delMsgs(), 2000);
    },
    delMsgs: function () {
      this.status = "";
      this.message = "";
      this.status2 = "";
      this.message2 = "";
      this.messageError = "";
    },
    findProd: async function (atributo, valor, data) {
      this.messageError = "";

      let secundarios = [];
      for (const item of data.atributosFilt) {
        if (item.atributo != atributo) {
          secundarios.push({
            atributo: item.atributo,
            valor: item.sel,
          });
        }
      }

      let encontrados = [];
      for (const item of data.product_variantes) {
        for (const atributos of item.producto.product_atributo_valores) {
          if (atributos.atributo == atributo && atributos.valor == valor) {
            encontrados.push(item.producto);
            break;
          }
        }
      }

      if (encontrados.length == 0) {
        const att = atributo.toLowerCase();
        this.messageError = `No hay mas variantes disponibles por el momento para ${att} ${valor}.`;
        this.delStatus();
        return null;
      }

      let coincidencias = [];
      let producto = encontrados[0];
      if (encontrados.length > 1) {
        for (const producto of encontrados) {
          let count = 0;
          for (const atributos of producto.product_atributo_valores) {
            for (const attsec of secundarios) {
              if (
                atributos.atributo == attsec.atributo &&
                atributos.valor == attsec.valor
              ) {
                count++;
                break;
              }
            }
          }
          coincidencias.push(count);
        }

        let encontrado = coincidencias[0];
        let index = 0;
        for (var i = 1; i < encontrados.length; i++) {
          if (coincidencias[i] > encontrado) {
            encontrado = coincidencias[i];
            index = i;
          }
        }

        producto = encontrados[index];
      }

      if (producto.id) {
        let payload = {
          option: "product",
          id: producto.id,
        };
        await this.getInfoByIdPrd(payload);
        this.selectNumb = 1;
        const url = "/producto/" + this.data.url;
        this.$router.push(url).catch((err) => { });
        let ruta;
        if (this.data.status === 'INACTIVO') {
          ruta = this.data.product_variantes.find(producto => producto.producto.status === 'ACTIVO').producto.url
        }

        if (ruta) {
          window.location.href = `/producto/${ruta}`;
        }
      }
    },





    stopDrag() {
      this.drag = false;
      this.dragX = this.dragY = "no";
    },

    stopDragT() {
      let body = document.getElementsByTagName("body")[0];
      this.drag = false;
      body.style.height = "auto";
      body.style.overflow = "auto";
      this.dragXt = this.dragYt = "no";
    },

    srcImg: function (img) {
      let src = `${url}/product-img/${img}`;
      //this.status_img(img)
      return src;
    },


    loadData() {
      this.mdcar = localStorage.getItem("mdc") === "false" ? false : localStorage.getItem("mdc") === "true" ? true : false
    },

  },
  mounted() {
    window.addEventListener("mouseup", this.stopDrag);
    window.addEventListener("touchend", this.stopDragT);
    this.loadData()
  },
};
</script>
<style scoped>
@import url('./producto.css');
</style>
